import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHorizontalAlignmentCenter: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconHorizontalAlignmentCenter"><Path d="M6 4V11H3V13H6V20H11V13H13V18H18V13H21V11H18V6H13V11H11V4H6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHorizontalAlignmentCenter;
